<script>
import { api } from '../../../firebase'
import ImageTemplatesTable from './ImageTemplatesTable'
import LoadingView from '../utils/LoadingView'

export default {
  name: 'LoadingImageTemplatesTable',
  components: {
    LoadingView,
    ImageTemplatesTable
  },
  props: {
    value: { type: Array, required: false, default: () => [] },
    loadingState: {
      type: Object,
      required: false
    }
  },
  computed: {
    activeLoadingState() {
      return typeof this.$props.loadingState !== 'undefined' ? this.$props.loadingState : this.dataLoadingState
    },
    imageTemplates() {
      return this.activeLoadingState.data
    }
  },
  data() {
    return {
      dataLoadingState: {
        pending: false,
        data: [],
        error: null
      }
    }
  },
  methods: {
    async load() {
      const { results } = await api.imageTemplates.find({})
      return results
    },
    updateLoadingState(value) {
      this.$emit('update:loadingState', value)
      this.dataLoadingState = value
    }
  }
}
</script>

<template>
  <loading-view :load="load" :loadingState="activeLoadingState" @update:loadingState="updateLoadingState($event)">
    <template v-slot:pending>
      <image-templates-table
        :items="[]"
        :loading="activeLoadingState.pending"
        :value="value"
        @input="$emit('input', $event)"
        v-bind="$attrs"
      />
    </template>
    <template v-slot:done>
      <image-templates-table
        :items="imageTemplates"
        :loading="activeLoadingState.pending"
        :value="value"
        @input="$emit('input', $event)"
        v-bind="$attrs"
      />
    </template>
    <template v-slot:error>
      <v-alert color="red" :outlined="true" title="An error occurred while loading the image templates.">
        <p><strong>An error occurred while loading the image templates.</strong></p>
        <p>{{ loadingState.error.message }}</p>
      </v-alert>
    </template>
  </loading-view>
</template>

<style lang="scss" scoped></style>
